var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBronzeStages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 81,
    viewBox: "0 0 97 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.481445,
    y: 7.42188,
    width: 95.9718,
    height: 73.5775,
    fill: "url(#paint0_linear_10204_4270)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.481445 0.245117H82.4937L96.4533 7.42341H0.481445L0.481445 0.245117Z",
    fill: "#CF8C6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5586 64.6104C42.9056 64.6104 40.8141 64.3906 39.2842 63.9512C37.7542 63.4954 36.6312 63.0723 35.915 62.6816C35.4268 62.4375 35.3047 62.0387 35.5488 61.4854L37.2334 57.5059C37.4124 57.0827 37.6077 56.8467 37.8193 56.7979C38.0309 56.749 38.3239 56.8141 38.6982 56.9932C39.3493 57.3024 40.2201 57.6279 41.3105 57.9697C42.4173 58.2952 43.7113 58.458 45.1924 58.458C47.0316 58.458 48.4883 58.0755 49.5625 57.3105C50.653 56.5456 51.1982 55.4062 51.1982 53.8926C51.1982 52.3301 50.5146 51.1501 49.1475 50.3525C47.7965 49.5387 45.9329 49.1318 43.5566 49.1318H42.9951C42.6045 49.1318 42.3115 49.0667 42.1162 48.9365C41.693 48.6598 41.2536 48.3343 40.7979 47.96C40.3584 47.5693 39.8783 47.0973 39.3574 46.5439C39.1947 46.3324 39.1133 46.1696 39.1133 46.0557C39.1133 45.9092 39.1947 45.7464 39.3574 45.5674C39.8783 45.014 40.3584 44.5501 40.7979 44.1758C41.2536 43.7852 41.693 43.4515 42.1162 43.1748C42.3441 43.0446 42.637 42.9795 42.9951 42.9795H43.3125C47.8698 42.9795 50.1484 41.5065 50.1484 38.5605C50.1484 35.8913 48.4964 34.5566 45.1924 34.5566C44.0531 34.5566 43.0033 34.7031 42.043 34.9961C41.0827 35.2891 40.3096 35.582 39.7236 35.875C39.3493 36.054 39.0563 36.1191 38.8447 36.0703C38.6494 36.0052 38.4622 35.7773 38.2832 35.3867L36.6475 31.6514C36.4196 31.1143 36.5417 30.7074 37.0137 30.4307C37.7298 30.0563 38.8773 29.625 40.4561 29.1367C42.0348 28.6484 44.1019 28.4043 46.6572 28.4043C48.7894 28.4043 50.71 28.7298 52.4189 29.3809C54.1279 30.0319 55.487 31.0003 56.4961 32.2861C57.5052 33.5719 58.0098 35.1751 58.0098 37.0957C58.0098 41.6693 55.6904 44.5339 51.0518 45.6895V45.8115C53.4281 46.1208 55.3568 46.9915 56.8379 48.4238C58.319 49.8561 59.0596 51.7116 59.0596 53.9902C59.0596 56.334 58.4736 58.2952 57.3018 59.874C56.1462 61.4528 54.5511 62.641 52.5166 63.4385C50.4821 64.2197 48.1628 64.6104 45.5586 64.6104Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10204_4270",
    x1: 48.4674,
    y1: 7.42187,
    x2: 48.4674,
    y2: 80.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D14F13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F2408"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeStages);
export default __webpack_public_path__ + "static/media/bronzeStages.80962d990f5e3862e26079cf7b46f9d6.svg";
export { ForwardRef as ReactComponent };